export const StripeApiKeyString = "pk_live_51QScqpEx8sBWHhak3j191ilktbrcTT4EA69Kkhoish43nH7wdgucltBGfumjxDUfv38JKUHWj6qaqzj2IxYvncYf00uu6vgYNf"
